// 顯示名縮寫（以空白切 token）：
// - 只有一個 token → 原樣（不縮寫）
// - 第一個 token 永遠原樣（英文或中文皆然）
// - 第二個 token 起：長度 ≥ 2 的拉丁字母 token 縮成「首字母 + .」、單字母拉丁
//   token 只留首字母（不加點）、非拉丁 token 原樣保留
// - 間距：相鄰兩個「非首位、且都會加點」的拉丁 token 緊接不加空白（如
//   John M.L.）；其餘一律以單一空白分隔。單字母拉丁不加點也不緊接（如
//   Amy J Lee → Amy J L.），維持空白便於閱讀。「拉丁 / 非拉丁」以 token
//   首字所屬 Unicode script 判定
const isLatinToken = (token: string): boolean => {
  const normalized = token.normalize('NFC')
  if (normalized.length === 0) return false
  return /\p{Script=Latin}/u.test(normalized[0])
}

const isDottedLatinToken = (token: string): boolean =>
  isLatinToken(token) && token.length > 1

const abbreviateToken = (token: string): string => {
  if (!isLatinToken(token)) return token
  return token.length > 1 ? `${token[0]}.` : token
}

export function abbreviateName(name: string): string {
  const tokens = name.trim().split(/\s+/).filter(Boolean)
  if (tokens.length <= 1) return name

  return tokens.reduce((acc, token, index) => {
    if (index === 0) return token
    const tightJoin =
      index >= 2 &&
      isDottedLatinToken(token) &&
      isDottedLatinToken(tokens[index - 1])
    const piece = abbreviateToken(token)
    return tightJoin ? acc + piece : `${acc} ${piece}`
  }, '')
}
